/**
 * Figma's `menu/item`, in MUI spacing steps. `containerGap` separates the label group from a trailing
 * icon; `labelGap` is the tighter space between the leading glyph and the text.
 */
export const MENU_ITEM_SPACING = { py: 1, px: 1.5, containerGap: 1, labelGap: 0.75 };

/**
 * Figma's `MUI/menu/itemDefault`. Stated rather than left to `typography.body1`: that is 16px on the
 * global 1.4 body line-height (22.4px), so inheriting it would quietly take 1.6px off every row.
 */
export const MENU_ITEM_TYPE = { fontSize: "1rem", lineHeight: "1.5rem" };

/** Figma's `menu/item/label/icon`. */
export const MENU_ITEM_ICON_SIZE = 20;

export const ROW_TOOLTIP_WIDTH = 180;

export const TRAILING_TOOLTIP_WIDTH = 256;
